/**
 * removes all spaces from given string and returns the string without spaces
 * @param s
 * @returns
 */
function removeSpace(s: string) {
  let sReturn = ''
  for (let i = 0; i < s.length; i++) {
    if (s[i] !== ' ') sReturn += s[i]
  }
  return sReturn
}
/**
 * register this in @beforeinput to avoid any space input
 * @param event
 * @returns
 */
function beforeInputIgnoreSpace(event: InputEvent) {
  if (event.data === ' ') {
    event.preventDefault()
  }
  return
}

export { removeSpace, beforeInputIgnoreSpace }
